module.exports = __webpack_public_path__ + "img/m-home-logo.5dce716c.png";